import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DescriptionParserService } from 'app/core/services/parse-description.service';
import { Item, Menu } from '../../models/menu.model';
import { MenuService } from '../../services/menu.service';
import { PreloadImgComponent } from './../../../core/directives/preload-img/preload-img.component';
/**
 * Listado de items con foto o sin foto para menu en tabs
 */
@Component({
    selector: 'app-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    standalone: false
})
export class ItemComponent extends PreloadImgComponent implements OnInit {
  /**
   * Informacion del menu seleccionado
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Listado de productos
   */
  @Input() items: Item[] | undefined;
  /**
   * Indica el idioma seleccionado
   */
  language: string | undefined;
  constructor(
    private menuService: MenuService,
    public dialog: MatDialog,
    public descriptionParser: DescriptionParserService

  ) {
    super();
  }

  ngOnInit(): void {
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });
  }

}
